import type { FC } from 'react';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { DynamicProgrammingWrapper } from './DynamicProgramming.styled';

interface DynamicProgrammingProps {}

const DynamicProgramming: FC<DynamicProgrammingProps> = () => (
 <DynamicProgrammingWrapper>
    <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Dynamic Programming</h1>			
   </header>
   <div className="entry-content clear" itemProp="text">
      <p className="text-align-justify"><b>Think of it this way ~</b> Would you rather solve a puzzle by trying every possible combination, or by remembering which pieces you've already tried? Dynamic programming is like having a perfect memory for problem-solving.</p>
      <br/>
      <p className="text-align-justify">In this section of our training, we will be covering the following topics :</p>
      <ul className="text-align-justify">
         <li><a href="/what-is-dp">Introduction to Dynamic Programming and Memoization</a></li>
         <li><a href="/types-of-dp">Types of Dynamic Programming</a></li>
         <li><a href="/linear-dp">Linear DP</a></li>
         <li><a href="/kadane-algorithm">Kadane's Algorithm</a></li>
         <li><a href="/01-knapsack">0/1 Knapsack</a></li>
         <li><a href="/unbounded-knapsack">Unbounded Knapsack</a></li>
         <li><a href="/subsequence">Subsequence</a></li>
      </ul>
      <br />
      <EmbedYoutube videoType="video" videoList={["IwDRg40rXq8"]} />
   </div>
 </DynamicProgrammingWrapper>
);

export default DynamicProgramming;
